import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Leistungen from "./sections/Leistungen";
import Projects from "./sections/Projects";
import FeaturedWork from "./sections/FeaturedWork";
export default function HomePage() {
  return <div className="!h-[2900px]">
      <Header />
      <Hero />
      <Leistungen />
      <Projects />
      <FeaturedWork />
      <Contact />
      <Footer />
    </div>;
}